import React, { useState, useEffect, Component } from 'react';
import axiosInstance from './../../helpers/axiosInstance';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Skeleton from 'react-loading-skeleton';
import {
  Card,
  Button,
  NavLink,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  UncontrolledTooltip,
} from 'reactstrap';
import { parseJsonText } from 'typescript';

const MovementsProducts = (props) => {
  var createReactClass = require('create-react-class');
  const [isMovementLoading, setisMovementLoading] = useState(true);
  const [product, setproduct] = useState(props.product);
  const [listMovements, setlistMovements] = useState([]);
  const [list4Movements, setlist4Movements] = useState([]);

  useEffect(() => {
    getMovements(props.product, props.type);
  }, [props.filterMov]);

  const getMovements = (product, type) => {
    setisMovementLoading(true);
    let api = '/WSGYG39_2/api/Inquiries/CurrentAccountMovements';
    if (type === '2') api = '/WSGYG39_2/api/Inquiries/LoansMovements';
    if (type === '3') api = '/WSGYG39_2/api/Inquiries/CurrentAccountMovements';
    if (type === '6') api = '/WSGYG39_2/api/Inquiries/LoansMovements';
    if (type === '7') api = '/WSGYG39_2/api/Inquiries/CdtMovements';
    async function getMovementsAsync() {
      const body = {
        AccountNumber: product.accountNumber,
        Parameters: [product.accountNumber],
      };
      console.log(`MovementsProduct @@@@@@@@@@@ api: ${api}, type: ${type}`);
      const request = await axiosInstance()
        .post(api, body)
        .catch((err) => {
          setisMovementLoading(false);
          return 'err';
        });
      if (request != 'err') {
        setlistMovements(request.data.transactionHistory);
        setlist4Movements(request.data.transactionHistory.slice(0, 4));
        setisMovementLoading(false);
      }
      return request;
    }
    getMovementsAsync();
  };

  var Movements = (props) => {
    var data = props.data;
    var newsTemplate;
    let newFechaI = props.newFechaI;
    let newFechaF = props.newFechaF;
    setproduct(props.producto);
    if (data != null) {
      if (isMovementLoading) {
        newsTemplate = (
          <div>
            <Skeleton
              height={80}
              count={4}
              className="card-transaction-info"
              style={{ width: '100%' }}
            ></Skeleton>
          </div>
        );
      } else {
        if (props.filterMov) {
          const listFilterFecha = data.filter((item) => {
            const fechaObj = new Date(item.transactionDate);
            const fechaInicioObj = new Date(newFechaI);
            const fechaFinObj = new Date(newFechaF);

            return fechaObj >= fechaInicioObj && fechaObj <= fechaFinObj;
          });
          console.log(listFilterFecha);
          newsTemplate = listFilterFecha.map(function (item, index) {
            return (
              <div key={index}>
                <Movement data={item} style={{ width: '100%' }} />
              </div>
            );
          });
        } else {
          newsTemplate = data.slice(0, 4).map(function (item, index) {
            return (
              <div key={index}>
                <Movement data={item} style={{ width: '100%' }} />
              </div>
            );
          });
        }
      }
    } else {
      newsTemplate = <p>Hoy no se han generado movimientos</p>;
    }
    return (
      <div style={{ fontWeight: 'bold', width: '100%' }}>{newsTemplate}</div>
    );
  };

  var Movement = createReactClass({
    render: function () {
      var Date = this.props.data.transactionDate.substring(5, 10),
        DateYear = this.props.data.transactionDate.substring(0, 4),
        Description = this.props.data.transactionName,
        Account = product.accountNumber,
        Value = this.props.data.transactionBalance,
        color =
          this.props.data.sign === '' || this.props.data.sign === undefined
            ? 'text-grissantander'
            : this.props.data.sign === '+'
            ? 'text-green'
            : 'text-primary';
      return (
        <div
          className="card-transaction-info ml-5 mr-5"
          style={{ marginBottom: '24px' }}
        >
          <Row style={{ alignItems: 'center' }}>
            <div
              className="col-auto mr-3 text-medium-grey ml-2"
              style={{ alignItems: 'center' }}
            >
              <p style={{ marginBottom: 0, fontSize: '12px' }}>
                {DateYear}
                <br />
                {Date}
              </p>
            </div>
            <div className="col">
              <Row>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: 10 + 'px',
                  }}
                >
                  <p
                    style={{
                      fontWeight: 700,
                      margin: '2px 0 0 0px',
                      fontSize: '12px',
                    }}
                  >
                    {Description}
                  </p>
                </div>
              </Row>
              <Row>
                <span
                  style={{ marginBottom: 0, marginLeft: '10px' }}
                  class="mb-2 text-sm"
                >
                  {Account}
                </span>
              </Row>
            </div>
            <div className="col-auto mr-3 vertical-center">
              <h6
                style={{
                  fontWeight: 400,
                  fontSize: 1 + 'rem',
                  marginBottom: 0,
                }}
                className={color}
              >
                <i className="fas fa-dollar-sign" />
                {Value}
                <span class="decimal-numbers-format"></span>
              </h6>
            </div>
          </Row>
        </div>
      );
    },
  });

  props.functionListMov(list4Movements);

  return (
    <>
      <Movements
        data={listMovements}
        producto={props.product}
        newFechaI={props.newFechaI}
        newFechaF={props.newFechaF}
        filterMov={props.filterMov}
      ></Movements>
    </>
  );
};

export default MovementsProducts;
